import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';

import SoftBadge from 'components/common/SoftBadge';
import Flex from 'components/common/Flex';
import CardDropdown from 'components/common/CardDropdown';


const CandidatesColumns = (handleEditQuestion, handleDeleteQuestion) => [
    {
        accessor: 'index',
        Header: '#',
        headerProps: {
            style: { width: '50px', minWidth: '50px', maxWidth: '50px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '50px', minWidth: '50px', maxWidth: '50px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'id', 
        Header: 'ID',
        headerProps: { className: 'hidden-column' },
        cellProps: {
              className: 'hidden-column'
        },
    },
    { 
        accessor: 'section', 
        Header: 'Sección',
        headerProps: {
            style: { width: '100px', minWidth: '30px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '100px', minWidth: '30px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'instruction', 
        Header: 'Instrucción',
        headerProps: {
            style: { width: '250px', minWidth: '30px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '250px', minWidth: '30px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'question', 
        Header: 'Pregunta',
    },
    { 
        accessor: 'answer', 
        Header: 'Respuesta correcta',
    },
    { 
        accessor: 'points', 
        Header: 'Puntos',
        headerProps: {
            style: { width: '75px', minWidth: '75px', maxWidth: '75px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '75px', minWidth: '75px', maxWidth: '75px', textAlign: 'center' } // Establece el ancho fijo de la columna
        },
    },
    {
        accessor: 'none',
        Header: '',
        disableSortBy: true,
        headerProps: {
            style: { width: '60px', minWidth: '60px', maxWidth: '60px' }  // Ancho pequeño para el ícono del dropdown
        },
        cellProps: {
            className: 'text-end',
            style: { width: '60px', minWidth: '60px', maxWidth: '60px' }  // Ancho pequeño para el ícono del dropdown
        },
        Cell: rowData => {
            const { id } = rowData.row.original;
            return (
                <CardDropdown>
                    <div className="py-2">
                        <Dropdown.Item onClick={() => handleEditQuestion(id)}>Editar</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item className="text-danger" onClick={() => handleDeleteQuestion(id)}>Eliminar</Dropdown.Item>
                    </div>
                </CardDropdown>
            );
        }
    }
];

export default CandidatesColumns;